import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    flashMessage: {
        message: null,
        type: null,
    },
    showSideMenu: false,
    isUserMenuOpen: false
  },
  mutations: {
    showFlashMessage (state, flashMessage) {
      state.flashMessage = flashMessage;
    },
    cleanFlashMessage(state) {
        state.flashMessage.message = null;
    },
    setShowSideMenu(state, value){
      state.showSideMenu = value;
    },
    setIsUserMenuOpen(state, value){
      state.isUserMenuOpen = value;
    },
  }
})